
















































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {StInputEnum} from '@/components/basic/StInputEnum';
import StDurationPicker from '@/components/basic/StDurationPicker.vue';

@Component({
    components: {
        StDurationPicker
    },
})
export default class StInput extends Vue {
    @Prop()name!: string;
    @Prop()rules!: string;
    @Prop()type!: StInputEnum;
    @Prop()value!:any;
    @Prop()inputClass!: string;
    @Prop()disabled!:boolean;
    @Prop()valImmediate!:boolean;
    @Prop()placeholder!: string;

    get currencyValue(){
        if(!this.value || !this.value.toFixed){
            return this.value;
        }
        return this.value.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    get numberValue(){
        if(!this.value){
            return this.value;
        }

        return this.value.toString().replace('.',',');
    }

    get hasAppendSlot(){
        return this.$slots.append;
    }

    get tagType(){
        if(this.type == StInputEnum.Email || this.type == StInputEnum.Text || this.type == StInputEnum.Password){
            return 'input'
        }

        return this.type;
    }

    numberChanged(event: any){
        let result = event.target.value;

        if(!result){
            this.$emit('input',0);
            return;
        }

        result = result.replace(',','.');


        if(!result.match( /^(\d+\.?\d*|\.\d+)$/ )){
            return;
        }

        this.$emit('input', result);
        // this.$emit('input', result.replace(/^0+/, ''));
    }

    @Emit('input')
    inputCurrency(event:any){
        this.$forceUpdate();

        let val = event.target.value;
        val = val.replace(',','.');

        if(!parseFloat(val)){
            return 0;
        }

        return parseFloat(val);
    }

    @Emit('input')
    inputValue(val: any){
        return val;
    }

    @Emit('input')
    input(event:any){
        return event.currentTarget.value;
    }
}
